module.exports = __webpack_public_path__ + "img/lock-closed-outline.4f02cdf1.svg";